import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid, TextField, Input, InputAdornment, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TagsKanbanContainer } from "../TagsKanbanContainer";

const useStyles = makeStyles((theme) => ({
	cardHeader: {
		cursor: "pointer",
		minWidth: 0,
		padding: theme.spacing(0.75, 1),
		borderRadius: 8,
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: theme.mode === "light" ? "#f3f8ff" : "#3a3a3a",
		},
	},
	avatar: {
		width: 42,
		height: 42,
		border: theme.mode === "light" ? "2px solid #e7eef8" : "2px solid rgba(255,255,255,0.12)",
	},
	title: {
		color: theme.mode === "light" ? "#172033" : "#f8fafc",
		fontWeight: 800,
		fontSize: 15,
	},
	subheader: {
		color: theme.mode === "light" ? "#64748b" : "#cbd5e1",
		fontSize: 12,
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();
	const [amount, setAmount] = useState("");

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				className={classes.cardHeader}
				titleTypographyProps={{ noWrap: true, className: classes.title }}
				subheaderTypographyProps={{ noWrap: true, className: classes.subheader }}
				avatar={<Avatar className={classes.avatar} src={contact?.urlPicture} alt="contact_image" />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={
					ticket.user &&
					`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
				}

			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={1}>
				{/* Conteúdo do contato à esquerda */}
				<Grid item xs={12}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
